import InitialScreen from "../../layouts/InitialScreen";

export default function Initial() {
	return (
		<>
			<InitialScreen />
		</>
	);
}
